<template>
  <v-layout>
    <v-main class="pt-0" :min-height="$vuetify.display.mdAndUp ? 800 : 550">
      <v-card 
        height="700px"
        :image="img"  
        flat 
        color="transparent"
      >
      <v-container class="  d-flex align-start justify-start pa-6 ma-0">
        <v-row align="start" class="ma-0 pa-0">
          <v-col cols="12" md="7" class="ma-0 pa-0" >


            <h1 class="text-h3 text-md-h2 font-weight-bold my-6">{{ title }} </h1>
            <div class="text-h6 text-medium-emphasis mt-10"> {{ subtitle }} </div>
            
            <div v-if="btext">
              <v-btn
                  class="mr-4"
                  color="#0071E3"
                  size="large"
                  width="30vw"
                  height="7vh"
                  :text="btext"
                  variant="flat"
                  @click="navigate"
                  :href="link"
                  :route="route"
                />
            </div>




          


          </v-col>

          <v-col xclass="hidden-sm-and-down" cols="6" >
            <div class="me-n12">
              <v-sheet  class="ps-4 py-4" color="transparent" rounded="s-lg">
                <v-img
                  xxclass="border-s border-t border-b"
                  fill
                  max-height="500"
                  position="right"
                  :rounded="$vuetify.display.smAndDown ? true : 's-lg'"
                  :src="img2"
                />
              </v-sheet>
            </div>
          </v-col>
        </v-row>

        <!-- <div class="v-bg position-absolute top-0 right-0 left-0 bottom-0">
          <div aria-hidden="true" class="overflow-hidden opacity-20 w-100 h-100" />
        </div> -->
      </v-container>
      </v-card>
    </v-main>
  </v-layout>
</template>

<script setup>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'
  const theme = useTheme()
  const src = computed(() => `https://cdn.vuetifyjs.com/docs/images/one/snips/screenshots/vuetify-cards-${!theme.current.value.dark ? 'light' : 'dark'}.png`)



import { useRouter } from "vue-router";

const router = useRouter();

const navigate = () => {
  if (props.route) {
    router.push({ name: props.route });
  }
};


  defineProps([
"title",
"subtitle",
"clr",
"btext",
"link",


"img",
"img2"

]);




</script>

<!-- <style scoped>
  .v-bg {
    pointer-events: none;
    filter: blur(56px);
  }

  .v-bg > div {
    background: linear-gradient(
      to bottom right,
      rgb(var(--v-theme-info)),
      rgb(var(--v-theme-primary))
    );
    z-index: -40;
    clip-path: polygon(10% 10%, 20% 10%, 70% 80%, 60% 80%, 30% 5%, 40% 10%, 50% 30%, 60% 50%, 50% 5%, 55% 15%, 45% 15%, 50% 5%, 30% 80%, 40% 85%, 35% 95%, 25% 90%);
  }
</style> -->

